export default __webpack_public_path__ + "static/PC_1_4-523aee52b01e266ff263256158bcf733.png";